/**
 * Collections List Interactive Functionality
 * IMPROVED HOVER STRATEGY - Global state management
 */

(function() {
  'use strict';

  // Global state management
  let currentActiveCard = null;
  let hoverTimeout = null;
  
  // Detect if device is mobile/touch
  const isTouchDevice = () => {
    return ('ontouchstart' in window) || 
           (navigator.maxTouchPoints > 0) || 
           (navigator.msMaxTouchPoints > 0);
  };

  // Hide ALL subcollections across all cards
  function hideAllSubcollections() {
    const allCards = document.querySelectorAll('.collection-card');
    allCards.forEach(card => {
      const chevron = card.querySelector('.chevron-icon');
      const subcollectionsOverlay = card.querySelector('.subcollections-overlay');
      const subcollectionItems = card.querySelectorAll('.subcollection-item');
      
      // Hide chevron
      if (chevron) {
        chevron.classList.remove('rotated');
      }
      
      // Hide overlay
      if (subcollectionsOverlay) {
        subcollectionsOverlay.classList.remove('active');
      }
      
      // Hide all items
      subcollectionItems.forEach(item => {
        item.classList.remove('active');
      });
      
      // Update ARIA
      card.setAttribute('aria-expanded', 'false');
    });
    
    currentActiveCard = null;
  }

  // Show subcollections for specific card
  function showSubcollections(cardId) {
    const card = document.querySelector(`[data-collection-id="${cardId}"]`);
    if (!card) return;
    
    const chevron = card.querySelector('.chevron-icon');
    const subcollectionsOverlay = card.querySelector('.subcollections-overlay');
    const subcollectionItems = card.querySelectorAll('.subcollection-item');
    
    // Show chevron
    if (chevron) {
      chevron.classList.add('rotated');
    }
    
    // Show overlay
    if (subcollectionsOverlay) {
      subcollectionsOverlay.classList.add('active');
    }
    
    // Show items with staggered animation
    subcollectionItems.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add('active');
      }, index * 100); // Faster animation
    });
    
    // Update ARIA
    card.setAttribute('aria-expanded', 'true');
    currentActiveCard = cardId;
  }

  // Handle card hover enter
  function handleCardHoverEnter(cardId, subcollectionsCount) {
    // Clear any pending timeout
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      hoverTimeout = null;
    }
    
    // Only proceed if card has subcollections
    if (subcollectionsCount === 0) return;
    
    // If this card is already active, do nothing
    if (currentActiveCard === cardId) return;
    
    // Hide all other cards first
    hideAllSubcollections();
    
    // Small delay to prevent flickering
    hoverTimeout = setTimeout(() => {
      showSubcollections(cardId);
    }, 50);
  }

  // Handle card hover leave
  function handleCardHoverLeave(cardId) {
    // Clear any pending timeout
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      hoverTimeout = null;
    }
    
    // Add delay before hiding to prevent flickering when moving between elements
    hoverTimeout = setTimeout(() => {
      if (currentActiveCard === cardId) {
        hideAllSubcollections();
      }
    }, 100);
  }

  // Handle card click (toggle pin state)
  function handleCardClick(cardId, subcollectionsCount) {
    if (subcollectionsCount === 0) return;
    
    // If card is currently active, hide it
    if (currentActiveCard === cardId) {
      hideAllSubcollections();
    } else {
      // Show this card (hide others first)
      hideAllSubcollections();
      setTimeout(() => {
        showSubcollections(cardId);
      }, 50);
    }
  }

  // Setup card interactions
  function setupCardInteractions() {
    const cards = document.querySelectorAll('.collection-card');
    
    cards.forEach(card => {
      const cardId = card.dataset.collectionId;
      const collectionHandle = card.dataset.collectionHandle;
      const subcollectionsCount = parseInt(card.dataset.subcollectionsCount) || 0;
      
      if (!cardId) return;
      
      console.log(`Setting up card: ${cardId}, subcollections: ${subcollectionsCount}`);

      // Cards WITH subcollections - Interactive behavior
      if (subcollectionsCount > 0) {
        
        if (isTouchDevice()) {
          // MOBILE/TOUCH BEHAVIOR - Only click, no hover
          card.addEventListener('click', (e) => {
            if (!e.target.closest('.subcollection-link')) {
              e.preventDefault();
              handleCardClick(cardId, subcollectionsCount);
            }
          });

          // Accessibility
          card.setAttribute('tabindex', '0');
          card.setAttribute('role', 'button');
          card.setAttribute('aria-expanded', 'false');
          card.setAttribute('aria-label', 'Tap to view collections');
          
        } else {
          // DESKTOP BEHAVIOR - Hover + Click
          
          // Mouse enter - ONLY on the main card, not subcollections
          card.addEventListener('mouseenter', (e) => {
            // Only trigger if we're entering the main card area
            if (!e.target.closest('.subcollections-overlay')) {
              handleCardHoverEnter(cardId, subcollectionsCount);
            }
          });
          
          // Mouse leave - Only when actually leaving the card
          card.addEventListener('mouseleave', (e) => {
            // Only trigger if we're actually leaving the card completely
            handleCardHoverLeave(cardId);
          });
          
          // Click - Toggle pin state
          card.addEventListener('click', (e) => {
            if (!e.target.closest('.subcollection-link')) {
              e.preventDefault();
              handleCardClick(cardId, subcollectionsCount);
            }
          });

          // Accessibility
          card.setAttribute('tabindex', '0');
          card.setAttribute('role', 'button');
          card.setAttribute('aria-expanded', 'false');
          card.setAttribute('aria-label', 'Hover to view collections, click to pin');
        }

        // Keyboard accessibility (both mobile and desktop)
        card.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleCardClick(cardId, subcollectionsCount);
          }
        });

      } else {
        // Cards WITHOUT subcollections - Direct navigation
        
        card.addEventListener('click', (e) => {
          e.preventDefault();
          if (collectionHandle) {
            window.location.href = `/collections/${collectionHandle}`;
          }
        });
        
        // Keyboard navigation
        card.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (collectionHandle) {
              window.location.href = `/collections/${collectionHandle}`;
            }
          }
        });
        
        card.style.cursor = 'pointer';
        card.setAttribute('tabindex', '0');
        card.setAttribute('role', 'link');
        card.setAttribute('aria-label', `View ${card.querySelector('.collection-title')?.textContent || 'collection'}`);
      }
    });
  }

  // Global click outside handler
  function setupGlobalClickHandler() {
    document.addEventListener('click', (e) => {
      // If clicking outside any collection card, hide all subcollections
      if (!e.target.closest('.collection-card')) {
        hideAllSubcollections();
      }
    });
    
    // Also hide on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        hideAllSubcollections();
      }
    });
  }

  // Initialize on DOM content loaded
  function initializeCollectionsList() {
    console.log('Initializing Collections List with improved hover management...');
    
    // Ensure all subcollections are hidden initially
    hideAllSubcollections();
    
    // Setup card interactions
    setupCardInteractions();
    
    // Setup global handlers
    setupGlobalClickHandler();
  }

  // Shopify theme events
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCollectionsList);
  } else {
    initializeCollectionsList();
  }

  // Handle Shopify section reloads (theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId && event.target.classList.contains('section-collections-list')) {
      console.log('Collections List section reloaded');
      setTimeout(initializeCollectionsList, 100);
    }
  });

  // Export for potential external use
  window.CollectionsListApp = {
    hideAll: hideAllSubcollections,
    show: showSubcollections,
    currentActive: () => currentActiveCard,
    initialize: initializeCollectionsList
  };

})();